import apiClient from "../axios";
import store from 'store';

let querystring = require('querystring');

export async function login(email, password, captchaToken) {
    return await apiClient
        .post(
            '/auth/login',
            querystring.stringify({
                UserName: email,
                Password: password,
                captchaToken: captchaToken,
                grant_type: 'password',
            }),
            {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
            },
        )
        .then(response => {
            if (response) {
                const {
                    access_token,
                    obj,
                    UserFullName,
                    refresh_token,
                    Version,
                    pwd_change_required
                } = response.data;
                if (access_token) {
                    store.set('accessToken', access_token);
                    store.set('refresh_token', refresh_token);
                    store.set('obj', obj);
                    store.set('UserFullName', UserFullName);
                    store.set('Version', Version);
                    // Persisted so the forced-change screen survives a page reload.
                    // GetCurrentAccount does its own check and has no [Authorize], so it
                    // still answers a restricted token; without this the app shell would
                    // render after F5 even though every data call would come back 403.
                    store.set('username', email);
                    store.set('pwdChangeRequired', pwd_change_required === 'true' || pwd_change_required === true);
                }
                return response.data;
            }
            return false;
        })
        .catch(err => {
            console.log(err);
        });
}

export async function register(email, password, name) {
    return apiClient
        .post('/auth/register', {
            email,
            password,
            name,
        })
        .then(response => {
            if (response) {
                const {accessToken} = response.data;
                if (accessToken) {
                    store.set('accessToken', accessToken);
                    // store.set('accessToken', accessToken)
                }
                return response.data;
            }
            return false;
        })
        .catch(err => console.log(err));
}

export async function currentAccount() {
    return apiClient
        .get('/Authentication/GetCurrentAccount')
        .then(response => {
            if (response) {
                const access_token = response.data;
                if (access_token) {
                    store.set('accessToken', access_token);
                }
                return response.data;
            }
            window.location = window.location.origin;
            return
            if (!window.pathname === '/') window.location = '/auth/404';
        })
        .catch(err => {
            console.log(err);
        });
}

export async function changePassword(currentPassword, newPassword) {
    return apiClient
        .post('/Password/Change', {currentPassword, newPassword})
        .then(response => {
            if (!response) return {response: false, message: 'No response from the server.'};
            try {
                // Mutation convention: Ok(string), so the body is JSON-parsed a second time.
                const parsed = JSON.parse(response.data);
                return {response: !!parsed[0].response, message: parsed[0].message};
            } catch (e) {
                return {response: false, message: 'Unexpected response from the server.'};
            }
        })
        .catch(err => {
            console.log(err);
            return {response: false, message: 'Unable to reach the server. Please try again.'};
        });
}

export async function logout() {
    return apiClient
        .get('/auth/logout')
        .then(() => {
            store.remove('accessToken');
            store.remove('pwdChangeRequired');
            store.remove('username');
            return true;
        })
        .catch(err => {
            // The token has to go even if the server call fails, or a restricted
            // session would survive a sign-out.
            store.remove('accessToken');
            store.remove('pwdChangeRequired');
            store.remove('username');
            console.log(err);
        });
}
